import Logo from "@/components/Logo";
import { BUSINESS, NAV_LINKS, MAIN_SERVICES } from "@/data/content";

export default function Footer() {
  const scrollTo = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
    else if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="relative border-t border-white/8 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-24 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Logo />
            <p className="mt-6 text-sm text-zinc2 leading-relaxed max-w-xs">
              Luxury custom homes, remodeling and complete renovations across the
              Dallas–Fort Worth Metroplex.
            </p>
          </div>
          <div className="lg:col-span-2">
            <h3 className="font-mono text-[10px] tracking-[0.3em] uppercase text-goldw mb-5">Explore</h3>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    onClick={(e) => scrollTo(e, l.href)}
                    className="text-sm text-zinc2 hover:text-goldw transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-3">
            <h3 className="font-mono text-[10px] tracking-[0.3em] uppercase text-goldw mb-5">Services</h3>
            <ul className="space-y-3">
              {MAIN_SERVICES.map((s) => (
                <li key={s.num}>
                  <a
                    href="#services"
                    data-testid={`footer-service-${s.num}`}
                    onClick={(e) => scrollTo(e, "#services")}
                    className="text-sm text-zinc2 hover:text-goldw transition-colors"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
              <li><span className="text-sm text-zinc2">Interior Design &amp; Material Selection</span></li>
            </ul>
          </div>
          <div className="lg:col-span-3">
            <h3 className="font-mono text-[10px] tracking-[0.3em] uppercase text-goldw mb-5">Contact</h3>
            <ul className="space-y-3 text-sm text-zinc2">
              <li>
                <a href={BUSINESS.phoneHref} data-testid="footer-phone-link" className="hover:text-goldw transition-colors">{BUSINESS.phone}</a>
              </li>
              <li>
                <a href={`mailto:${BUSINESS.email}`} data-testid="footer-email-link" className="hover:text-goldw transition-colors break-all">{BUSINESS.email}</a>
              </li>
              <li className="leading-relaxed">{BUSINESS.address}</li>
              <li>{BUSINESS.hours}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 select-none" aria-hidden="true">
          <div className="font-serif font-light text-outline text-[18vw] lg:text-[11rem] leading-[0.85] tracking-tight whitespace-nowrap text-center">
            AMAA
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[11px] text-zinc3" data-testid="footer-copy">
            © {new Date().getFullYear()} AMAA Constructions · AMAA Design &amp; Build. All rights reserved.
          </p>
          <p className="text-[11px] text-zinc3 text-center sm:text-right">
            Luxury home builder · Custom homes · Kitchen &amp; bathroom remodeling · Farmers Branch, TX — serving Dallas–Fort Worth
          </p>
        </div>
      </div>
    </footer>
  );
}
